<template>
  <div>
    <group-form
      :is-group-form-sidebar-active.sync="isGroupFormSidebarActive"
      :group-data="groupData"
      @refetch-data="refetchData"
    />
    <navigation-form
      :is-navigation-form-sidebar-active.sync="isNavigationFormSidebarActive"
      :navigation-data="navigationData"
      @refetch-data="refetchData"
    />
    <b-card no-body>
      <div class="m-2">
        <div class="d-flex align-items-center justify-content-end">
          <b-button variant="primary" @click="addGroup">
            <span class="text-nowrap">Add Group</span>
          </b-button>
        </div>
      </div>
    </b-card>
    <b-card v-for="(ng, key) in groups" :key="'group' + key" action-collapse>
      <b-card-header class="pb-50">
        <b-row class="w-100">
          <b-col cols="10">
            <h3>
              {{ ng.title }}
            </h3>
          </b-col>
          <b-col cols="2">
            <div class="d-flex align-items-center justify-content-end">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="success"
                class="btn-icon"
                @click="updateGroup(ng)"
              >
                <feather-icon icon="EditIcon" />
              </b-button>
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="danger"
                class="btn-icon ml-1"
                @click="deleteGroupconfirm(ng.id)"
              >
                <feather-icon icon="XIcon" />
              </b-button>
            </div>
          </b-col>
        </b-row>
      </b-card-header>
      <div class="d-flex align-items-center mb-2">
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          @click="addNav(ng.id)"
          class="btn-icon"
        >
          <feather-icon icon="PlusCircleIcon" />
        </b-button>
      </div>

      <vue-tree-list
        @drop="testfunc"
        @drop-before="d_before"
        @drop-after="d_after"
        @delete-node="delfunc"
        :model="transformToTree(ng.navigations)"
        default-tree-node-name="new node"
        default-leaf-node-name="new leaf"
        v-bind:default-expanded="false"
      >
        <template v-slot:leafNameDisplay="slotProps" >
          <div class="d-flex justify-content-between ;" >
              <h3 class="d-flex " >
                {{ slotProps.model.title[currentLocale] }}
              </h3>
              <div class="d-flex align-items-center justify-content-end">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="success"
                  class="btn-icon"
                  @click="updateNav(slotProps.model)"
                >
                  <feather-icon icon="EditIcon" />
                </b-button>
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="danger"
                  class="btn-icon ml-1"
                  @click="deleteconfirm(slotProps.model.id)"
                >
                  <feather-icon icon="XIcon" />
                </b-button>
              </div>

          </div>
          
        </template>
        <span class="icon" slot="addTreeNodeIcon"></span>
      <span class="icon" slot="addLeafNodeIcon"></span>
      <span class="icon" slot="editNodeIcon"></span>
      <span class="icon" slot="delNodeIcon"></span>
      <span class="icon" slot="leafNodeIcon"></span>
      <span class="icon" slot="treeNodeIcon">󠀠 󠀠 󠀠</span>
      </vue-tree-list>
    </b-card>
  </div>
</template>
<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BTooltip,
  VBModal,
  BFormGroup,
  BFormCheckbox,
  BListGroupItem,
  BCardHeader,
  BCardBody,
} from "bootstrap-vue";
import BCardActions from "@core/components/b-card-actions/BCardActions.vue";
import Ripple from "vue-ripple-directive";
import { VueTreeList, Tree, TreeNode } from "vue-tree-list";

//api
import axios from "@axios";
import store from "@/store";
import { ref, onUnmounted } from "@vue/composition-api";
import useNavigationList from "./useNavigationList";
import navigationStoreModule from "../navigationStoreModule";
import GroupForm from "../navigation-form/GroupForm.vue";
import NavigationForm from "../navigation-form/NavigationForm.vue";

import draggable from "vuedraggable";
import Prism from "vue-prism-component";
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";
export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    VBModal,
    BFormGroup,
    BFormCheckbox,
    BCardActions,
    Prism,
    draggable,
    BListGroupItem,
    GroupForm,
    BCardHeader,
    BCardBody,
    NavigationForm,
    VueTreeList,
  },
  directives: {
    "b-modal": VBModal,
    Ripple,
  },
  computed: {
    currentLocale() {
      return this.$i18n.locale;
    },
  },
  setup() {
    const testfunc = (node, src, target) => {
      undateOrdering(node, "drop");
    };
    const d_before = (node, src, target) => {
      undateOrdering(node, "before");
      // console.log("dbefore", node.node, node.target);
    };
    const d_after = (node, src, target) => {
      undateOrdering(node, "after");
      // console.log("dafter", node.node, node.target);
    };

    const delfunc = (node) => {
      node.remove();
    };

    const NAVIGATION_STORE_MODULE_NAME = "app-navigation";
    if (!store.hasModule(NAVIGATION_STORE_MODULE_NAME))
      store.registerModule(NAVIGATION_STORE_MODULE_NAME, navigationStoreModule);
    onUnmounted(() => {
      if (store.hasModule(NAVIGATION_STORE_MODULE_NAME))
        store.unregisterModule(NAVIGATION_STORE_MODULE_NAME);
    });
    const {
      groups,
      undateOrdering,
      updateGroup,
      refetchData,
      isGroupFormSidebarActive,
      isNavigationFormSidebarActive,
      groupData,
      addGroup,
      addNav,
      updateNav,
      navigationData,
      deleteData,
      deleteGroupData,
    } = useNavigationList();

    const transformToTree = (navigations) => {
      const data = new Tree(navigations);
      return data;
    };
    return {
      groups,
      undateOrdering,
      updateGroup,
      refetchData,
      isGroupFormSidebarActive,
      isNavigationFormSidebarActive,
      groupData,
      addGroup,
      addNav,
      updateNav,
      navigationData,
      deleteData,
      deleteGroupData,
      transformToTree,
      testfunc,
      delfunc,
      d_after,
      d_before,
    };
  },
  data() {
    return {
      newTree: {},
    }
    },  methods: {
    deleteconfirm(id) {
      this.$bvModal
        .msgBoxConfirm(
          "Please confirm that you want to delete Navigation ID." + id,
          {
            title: "Please Confirm",
            size: "sm",
            okVariant: "danger",
            okTitle: "Yes",
            cancelTitle: "No",
            cancelVariant: "outline-secondary",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((value) => {
          if (value === true) {
            this.deleteData(id);
          }

          //this.deleteData(id)
        });
    },
    deleteGroupconfirm(id) {
      this.$bvModal
        .msgBoxConfirm(
          "Please confirm that you want to delete Group ID." + id,
          {
            title: "Please Confirm",
            size: "sm",
            okVariant: "danger",
            okTitle: "Yes",
            cancelTitle: "No",
            cancelVariant: "outline-secondary",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((value) => {
          if (value === true) {
            this.deleteGroupData(id);
          }

          //this.deleteData(id)
        });
    },
    allowDrag(model, component) {
      if (model.name === "Node 0-1") {
        // can't be dragged
        //return false;
      }
      // can be dragged
      return true;
    },
    allowDrop(model, component) {
      if (model.name === "Node 2-2") {
        // can't be placed
        //return false;
      }
      // can be placed
      return true;
    },
    curNodeClicked(model, component) {
      // console.log('curNodeClicked', model, component);
    },
    dragHandler(model, component, e) {
      // console.log('dragHandler: ', model, component, e);
    },
    dragEnterHandler(model, component, e) {
      // console.log('dragEnterHandler: ', model, component, e);
    },
    dragLeaveHandler(model, component, e) {
      // console.log('dragLeaveHandler: ', model, component, e);
    },
    dragOverHandler(model, component, e) {
      // console.log('dragOverHandler: ', model, component, e);
    },
    dragEndHandler(model, component, e) {
      // console.log('dragEndHandler: ', model, component, e);
    },
    dropHandler(model, component, e) {
      // console.log('dropHandler: ', model, component, e);
    },
  },
};
</script>
